import { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { getSettings } from '../lib/api';
import { Heart, Star, Users, Award } from 'lucide-react';
import { motion } from 'framer-motion';

export default function AboutPage() {
  const { t, lang, getLocalizedObj } = useLanguage();
  const [settings, setSettings] = useState({});
  useEffect(() => { getSettings().then(r => setSettings(r.data)).catch(console.error); }, []);
  const aboutText = getLocalizedObj(settings.about_text) || '';

  return (
    <div className="min-h-screen bg-[hsl(38,44%,96%)]">
      <section className="bg-[hsl(20,17%,12%)] text-white py-16 sm:py-20">
        <div className="mx-auto max-w-[72rem] px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-[family-name:var(--font-display)] text-3xl sm:text-4xl lg:text-5xl tracking-[var(--tracking-display)] mb-3">{t('about_title')}</h1>
          <p className="text-white/70 max-w-lg mx-auto">{t('about_subtitle')}</p>
        </div>
      </section>
      <div className="mx-auto max-w-[72rem] px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
            <img src="https://images.unsplash.com/photo-1696111677674-0e8a3168b46a?w=800&q=80" alt="Ristorante Little Italy" className="rounded-2xl shadow-lg w-full aspect-[4/3] object-cover" />
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}>
            <Heart className="w-8 h-8 mb-4 text-[hsl(16,55%,36%)]" />
            <h2 className="font-[family-name:var(--font-display)] text-2xl sm:text-3xl mb-6">Ristorante Little Italy</h2>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed mb-8">{aboutText}</p>
            <div className="grid grid-cols-3 gap-4">
              <div className="text-center p-4 bg-white rounded-xl border border-[hsl(32,17%,84%)]">
                <Award className="w-6 h-6 mx-auto mb-2 text-[hsl(42,72%,44%)]" />
                <div className="font-[family-name:var(--font-display)] text-2xl text-[hsl(16,55%,36%)]">103+</div>
                <div className="text-xs text-[hsl(22,10%,38%)] mt-1">{lang === 'en' ? 'Dishes' : 'Gerichte'}</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-[hsl(32,17%,84%)]">
                <Star className="w-6 h-6 mx-auto mb-2 text-[hsl(42,72%,44%)]" />
                <div className="font-[family-name:var(--font-display)] text-2xl text-[hsl(16,55%,36%)]">4.7</div>
                <div className="text-xs text-[hsl(22,10%,38%)] mt-1">Google Rating</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-[hsl(32,17%,84%)]">
                <Users className="w-6 h-6 mx-auto mb-2 text-[hsl(42,72%,44%)]" />
                <div className="font-[family-name:var(--font-display)] text-2xl text-[hsl(16,55%,36%)]">186+</div>
                <div className="text-xs text-[hsl(22,10%,38%)] mt-1">{t('reviews_count')}</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
